import { render, staticRenderFns } from "./CreateMessageModal.vue?vue&type=template&id=27945b7a&scoped=true&lang=pug&"
import script from "./CreateMessageModal.vue?vue&type=script&lang=js&"
export * from "./CreateMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMessageModal.vue?vue&type=style&index=0&id=27945b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27945b7a",
  null
  
)

export default component.exports